export function isValidDate(dateStr: string): boolean {
    let year: number, month: number, day: number;

    // Match DD/MM/YYYY
    const matchDMY = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (matchDMY) {
        day = parseInt(matchDMY[1], 10);
        month = parseInt(matchDMY[2], 10);
        year = parseInt(matchDMY[3], 10);
    } else {
        // Match YYYY-MM-DD
        const matchYMD = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (matchYMD) {
            year = parseInt(matchYMD[1], 10);
            month = parseInt(matchYMD[2], 10);
            day = parseInt(matchYMD[3], 10);
        } else {
            return false; // Invalid format
        }
    }

    // Check year is a positive integer (customize as needed)
    if (!Number.isInteger(year) || year < 1) return false;

    // Check month is 1-12
    if (!Number.isInteger(month) || month < 1 || month > 12) return false;

    // Days in each month (handle leap years)
    const daysInMonth = [
        31,
        isLeapYear(year) ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
    ];

    // Check day is valid for the month
    if (!Number.isInteger(day) || day < 1 || day > daysInMonth[month - 1]) return false;

    return true;
}

function isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}


export function isGreaterThanDate(dateStr: string, compareDateStr: string): boolean {
    const date = new Date(dateStr);
    const compareDate = new Date(compareDateStr);

    // Check if the date is valid
    if (isNaN(date.getTime()) || isNaN(compareDate.getTime())) {
        return false; // Invalid date
    }

    // Compare the two dates
    return date > compareDate;
}